import { CurecallButton, ECurecallSize } from '@honestica/curecall-ui'
import { useForm, SubmitHandler, FormProvider } from 'react-hook-form'
import { AuthBackButton } from '../_components/back-button.component'
import useCredentials from '../_components/auth.providers'
import { useTranslation } from 'react-i18next'
import { TRequestPin } from '../_components/auth.type'
import EmailField from 'src/components/email-field/email-field.component'

export default function Page() {
  const { t } = useTranslation()

  const methods = useForm<TRequestPin>()

  const { requestPin, isRequestPinLoading } = useCredentials()

  const onSubmit: SubmitHandler<TRequestPin> = ({ email }) => {
    if (!email) return
    requestPin({ email })
  }

  return (
    <div className="c-flex c-justify-center c-overflow-auto">
        <div className="c-flex c-flex-col  c-gap-8 c-w-3/4">
          <AuthBackButton />
          <h2 className="c-font-semibold">{t('pages.auth.title.request-pin')}</h2>

          <FormProvider {...methods}>
            <form
              action="#"
              method="POST"
              onSubmit={methods.handleSubmit(onSubmit)}
              className="c-w-full c-flex c-flex-col  c-gap-8 [&>*]:c-w-full"
            >
              <EmailField name="email" requiredMessageError={t('pages.auth.input.error')} />
              <CurecallButton
                isLoading={isRequestPinLoading}
                type="submit"
                className="c-max-w-fit"
                size={ECurecallSize.LARGE}
              >
                {t('pages.auth.cta.receive-email-code')}
              </CurecallButton>
            </form>
          </FormProvider>
        </div>
    </div>
  )
}
